import script from "./Input.vue?vue&type=script&lang=ts&setup=true"
export * from "./Input.vue?vue&type=script&lang=ts&setup=true"

import "./Input.vue?vue&type=style&index=0&id=a97ba0dc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a97ba0dc"]])

export default __exports__